<template>
	<div class="main-content">
		<div class="center-body">
			<Nav style="margin-bottom: 15px;"></Nav>
			<!--<div class="row">
				<img src="../../assets/img/newproductbanner.jpg" style="width: 100%;"/>
			</div>-->
			<div class="pro-box">
				<div class="wrap-row" >
					<div class="col-no adv-box" v-for="l in list" @click="toDetail(l.id)">
						<div style="height: 250px;width: 100%;overflow: hidden;display: flex;justify-content: center;align-items: center;">
							<img :src="l.pic" style="width: 100%;height: 250px;" />
						</div>
						<div class="item" style="color: #333;font-size: 16px;line-height: 20px;height:20px;margin-top: 8px;">
							{{l.name}}
						</div>
						<span style="color: #666;font-size: 14px;line-height: 2;overflow: hidden;height:20px;text-overflow:ellipsis;white-space:nowrap;">
							{{l.desc}}
						</span>
					</div>
				</div>
			</div>
		</div>	
	</div>
</template>

<script>
	import Nav from './nav.vue'
	export default {
		name: 'App',
		components: {
		    Nav
		},
		data() {
			return {
				list:[]
			}
		},
		methods: {
			toDetail(id){
				this.$localstorage.setStore('id',id);
				this.$router.push('detail')
			},
			getProductList() {
				var self = this
				this.$api.api.listNewPro().then(function(response) {
					if(response.data.code == 200) {
						self.list = response.data.data
					} else {
						self.$toast(response.data.msg);
					}

				})
			},
		},
		mounted() {
			this.getProductList();
		}
	}
</script>

<style scoped>
	.main-content {
		min-height: 100%;
		width: 100%;
		min-width: 1200px;
		margin: 0 auto;
		display: block;
		position: absolute;
		background: #fff;
		margin-top: 135px;
	}
	.center-body{
		/*width: 1200px;*/
		padding-bottom: 100px;
		margin: 0 auto;
	}
	.wrap-row{
		width: 1200px;
		margin: 0 auto;
	}
	.pro-box{
		margin-top: 25px;
	}
	.adv-box{
		width: 25%;
    padding: 0 10px;
    margin-top: 20px;
		justify-content: center;
    position: relative;
	}
	.adv-box img{
		width: 100%;
		height: 100%;
	}

	
</style>